import React from "react";
import OutstandingApprovalsPage from "./OutstandingApprovalsPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface OutstandingApprovalsPageContainerProps extends RouteProps, withValidUserRoleProps {}

const OutstandingApprovalsPageContainer = (props: OutstandingApprovalsPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <OutstandingApprovalsPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(OutstandingApprovalsPageContainer);
